import { getCookie } from "@/lib/getCookie";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Role } from "./Router";

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: Role[] }) => {
  // Check for token
  const token = getCookie("accessToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // check for roles
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const roleExists = loggedInUserData?.roles?.filter((userRole: Role) =>
    allowedRoles.includes(userRole)
  );

  return roleExists?.length ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
